// src/redux/slices/servicesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { servicesService } from '../../services/servicesService.js'
import { handleApiError } from '../../utils/handleApiError.js'

// Admin services with pagination (NEW)
export const fetchServicesAdmin = createAsyncThunk(
  'services/fetchServicesAdmin',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await servicesService.getServicesAdmin(params)
      return response.data
    } catch (error) {
      return rejectWithValue(handleApiError(error))
    }
  }
)

// Public services (YOUR EXISTING - unchanged)
export const fetchServices = createAsyncThunk(
  'services/fetchServices',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await servicesService.getServices(params)
      return response.data
    } catch (error) {
      return rejectWithValue(handleApiError(error))
    }
  }
)

export const fetchServiceBySlug = createAsyncThunk(
  'services/fetchServiceBySlug',
  async (slug, { rejectWithValue }) => {
    try {
      const response = await servicesService.getServiceBySlug(slug)
      return response.data
    } catch (error) {
      return rejectWithValue(handleApiError(error))
    }
  }
)

// Toggle service status (NEW)
export const toggleServiceStatus = createAsyncThunk(
  'services/toggleServiceStatus',
  async (id, { rejectWithValue }) => {
    try {
      const response = await servicesService.toggleServiceStatus(id)
      return response.data
    } catch (error) {
      return rejectWithValue(handleApiError(error))
    }
  }
)

const servicesSlice = createSlice({
  name: 'services',
  initialState: {
    services: [],
    currentService: null,
    loading: false,
    error: null,
    // Add pagination for admin (NEW)
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0,
      hasNext: false,
      hasPrev: false
    }
  },
  reducers: {
    clearCurrentService: (state) => {
      state.currentService = null
    },
    clearError: (state) => {
      state.error = null
    },
    // Add pagination setter (NEW)
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Services Admin (NEW)
      .addCase(fetchServicesAdmin.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchServicesAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.services = action.payload.services || []
        state.pagination = action.payload.pagination || state.pagination
        state.error = null
      })
      .addCase(fetchServicesAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Fetch Services (Public - YOUR EXISTING)
      .addCase(fetchServices.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false
        state.services = action.payload.services || action.payload
        state.error = null
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Fetch Service by Slug (YOUR EXISTING)
      .addCase(fetchServiceBySlug.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchServiceBySlug.fulfilled, (state, action) => {
        state.loading = false
        state.currentService = action.payload.service
        state.error = null
      })
      .addCase(fetchServiceBySlug.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Toggle Service Status (NEW)
      .addCase(toggleServiceStatus.fulfilled, (state, action) => {
        const updatedService = action.payload.service
        const index = state.services.findIndex(s => s._id === updatedService._id)
        if (index !== -1) {
          state.services[index] = updatedService
        }
      })
  }
})

export const { clearCurrentService, clearError, setPagination } = servicesSlice.actions
export default servicesSlice.reducer